import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { AlertModalComponent } from 'src/app/components/alert-modal/alert-modal.component';
import { ValidationDashService } from 'src/app/service/validation-dash.service';
import { ResponseStatus } from 'src/enum/responseEnum';

export interface UserData {
  reg_id: string
  user_id: string,
  contact_number: string,
  name: string,
  source: string,
  validation_status: string,
  language: string,
  answer_type: string,
  create_dt: string,
  submitted_dt: string,
  user_cat: string
}
const ELEMENT_DATA: UserData[] = []

@Component({
  selector: 'app-validation-dash-details',
  templateUrl: './validation-dash-details.component.html',
  styleUrls: ['./validation-dash-details.component.css']
})
export class ValidationDashDetailsComponent {

  @ViewChild('slickModal') slickModal: any;
  @ViewChild('audioPlayer') audioPlayer!: ElementRef;

  showLoading: boolean = false;
  downloadLoader: boolean = false;
  validationId: any = "";
  persentMode: any = "";
  registrationData: any = "";
  validationStatus: any = [];
  showRegistrationLoading: boolean = false;
  questionList: any = "";
  allowedExtensions = ['jpg', 'jpeg', 'png'];
  allowedExtensionFiles = ['pdf', 'doc', 'docx'];
  allowedExtensionSrcUrls = ['wav'];

  registrationListData = new MatTableDataSource(ELEMENT_DATA);
  registrationListColumnNoName = ['reg_id', 'contact_number', 'source', 'validation_status', 'submitted_dt', 'action']
  registrationListColumnAll = ['reg_id', 'contact_number', 'name', 'source', 'validation_status', 'submitted_dt', 'action']
  registrationListColumn: any;

  modalOption!: NgbModalOptions;

  /* statusList = [
    {id: "1", label: "Approve", value: "approve"},
    {id: "2", label: "On-Hold", value: "on-hold"},
    {id: "3", label: "Reject", value: "reject"},
  ] */

  slides: any;

  carouselConfig = {
    slidesToShow: 1,
    arrows: true,
    autoplay: false,
    infinite: false,
    prevArrow:
      '<button class="pbt vbtn"><img src="./assets/images/left-arrow.svg"></button>',
    nextArrow:
      '<button class="nbt vbtn"><img src="./assets/images/right-arrow.svg"></button>',
    autoplaySpeed: 3000,
    // variableWidth: true,
  };

  isShowImageSlider: boolean = false;
  audioSource: string = "";
  isPlaying: boolean = false;

  uiPrivileges: any = {};

  validationContestForm: any = FormGroup;

  showImageSlider(index?:any, item?: any) {
    this.isShowImageSlider = !this.isShowImageSlider;

    this.slides = this.filterUrlsByExtensions(item);

    console.log(this.slides, item, "item")

    this.slickModal.slickGoTo(index);
  }

  toggleImageSlider() {
    this.isShowImageSlider = !this.isShowImageSlider;
  }

  audio: HTMLAudioElement = new Audio();
  currentAudioUrl: string = '';
  audioUrls: string[] = [
    'https://d3rob536szhmrm.cloudfront.net/answers/373_1719823283682_q3.wav',
    'https://www2.cs.uic.edu/~i101/SoundFiles/BabyElephantWalk60.wav'
    // 'https://d3rob536szhmrm.cloudfront.net/answers/373_1719823283682_q3.wav',

    // 'https://www2.cs.uic.edu/~i101/SoundFiles/BabyElephantWalk60.wav',
    // 'https://www2.cs.uic.edu/~i101/SoundFiles/Fanfare60.wav',
    // 'https://www2.cs.uic.edu/~i101/SoundFiles/CantinaBand3.wav',
    // Add more audio URLs as needed
  ];

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute,public fb: FormBuilder, public validationService: ValidationDashService, private modalService: NgbModal) {
    /* const bars = document.querySelectorAll<HTMLElement>(".bar");
      bars.forEach((bar) => {
        // Random move
        const animationDuration = Math.random() * (0.7 - 0.2) + 0.2;
        bar.style.animationDuration = `${animationDuration}s`;
      }); */

      this.validationContestForm = this.fb.group({
        remarks: ['', Validators.compose([Validators.required, Validators.pattern(/^[^\s].+[^\s]$/)])],
        statusId: ['', Validators.required],
      });

      this.modalOption = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        windowClass: 'modal-medium-dialog'
      }

      let _uiPrivilege = localStorage.getItem("uiPrivileges")
      this.uiPrivileges = _uiPrivilege && JSON.parse(_uiPrivilege);
      if(this.uiPrivileges.nameInContestListing) {
        this.registrationListColumn = this.registrationListColumnAll;
      } else {
        this.registrationListColumn = this.registrationListColumnNoName;
      }

  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.validationId = params['id'];
      this.persentMode = params['type']

      if(this.persentMode == "1") {
        this.getContestEditDetails(this.validationId);
      } else {
        this.getContestViewDetails(this.validationId);
      }

    });



  }

  setupValidationForm(questionList:any): void {
    // console.log(questionList,"questionList")
    questionList?.map((questionItem:any, index:any) => {
      const controlName = `translation_${questionItem.aId}`;
      this.validationContestForm.addControl(controlName, this.fb.control([questionItem.translated_text, Validators.required]));
      this.validationContestForm.get(`translation_${questionItem.aId}`).setValue(questionItem.translated_text)
    });

    // console.log(this.validationContestForm.value,"validationContestForm");

  }


  async onSubmit() {
    // console.log(this.validationContestForm, "validationContestFormSubmit");
    if(this.validationContestForm.valid) {
      const formValue = this.validationContestForm.value;

      formValue.id = this.validationId;


      // console.log('Form Value:', formValue);


      this.showLoading = true;
      this.validationService.contestApprove(formValue).then((res:any) => {
        if (res.status === ResponseStatus.SUCCESS) {
          this.showLoading = false;
          this.router.navigateByUrl(`/validate-dash`);
        }
      }).catch((error:any) => {
        console.log(error);
        this.showLoading = false;
      })
    }


  }

  getContestViewDetails(id:any) {
    this.showLoading = true;
    this.validationService.fetchContestViewDetails(id).then((res:any) => {
      // console.log(res.records, "res.records view")
      this.registrationData = this.updateRegistrationDataObjects(res?.data?.registrationData);
      this.questionList = res?.data?.questions;
      this.showLoading = false;
    }).catch((error:any) => {
      console.log(error)
      this.showLoading = false;

    })
  }
  getContestEditDetails(id:any) {
    this.showLoading = true;
    this.showRegistrationLoading = false;
    this.validationService.fetchContestEditDetails(id).then((res:any) => {
      // console.log(res.records, "res.records edit")
      this.registrationData = this.updateRegistrationDataObjects(res?.data?.registrationData);

      if(!this.registrationData?.isEditEnabled) {

        this.isNotEditable();

      } else {
        this.validationStatus = res?.data?.validationStatus;
        this.registrationListData = this.updateObjects(res?.data?.otherSubmissions);
        this.questionList = res?.data?.questions;

        if(this.registrationData.remarks != "") {
          this.validationContestForm.get("remarks").setValue(this.registrationData?.remarks)
        }

        let isStatusPresent = this.validationStatus.some((item:any) => {
          return item.id === this.registrationData?.validation_status_id;
        });

        if(isStatusPresent) {
          this.validationContestForm.get("statusId").setValue(this.registrationData?.validation_status_id)
        }
        this.showLoading = false;
        this.showRegistrationLoading = false;
        this.setupValidationForm(this.questionList);
      }

    }).catch((error:any) => {
      console.log(error)
      this.showLoading = false;
      this.showRegistrationLoading = false;
    })
  }

  getRandomNumber(): number {
    return Math.random() * (0.7 - 0.2) + 0.2;
  }


  audioPlay(audioUrl: any, time: any): void {

    // console.log(audioUrl === this.currentAudioUrl , this.isPlaying, "this.audio.pause()")

    if (audioUrl === this.currentAudioUrl) {
      this.isPlaying = !this.isPlaying;
      if(this.isPlaying) {
        // console.log("play audio")
        this.audio.play();
      } else {
        // console.log("pause audio")
        this.audio.pause();
      }

    } else {
      this.http.get(audioUrl, { responseType: 'blob' }).subscribe((blob: Blob) => {
        this.audio.src = URL.createObjectURL(blob);
        this.audio.load();
        this.audio.play();
        this.currentAudioUrl = audioUrl;
        this.isPlaying = true;

        // Add event listener to detect when audio playback ends
        this.audio.addEventListener('ended', () => {
          // console.log('Audio playback ended');
          // Perform any actions you need after audio playback ends
          // For example, update UI, load next track, etc.
          this.isPlaying = false; // Update play state if needed
        });
      }, error => {
        console.error('Error fetching audio file:', error);
      });
    }
  }

  updateRegistrationDataObjects(obj:any) {
    return {
      id: obj.id || "-",
      reg_id: obj.reg_id || "-",
      contact_number: obj.contact_number || "-",
      name: obj.name || "-",
      email: obj.email || "-",
      status: obj.status || "-",
      source: obj.source || "-",
      pincode: obj.pincode || "-",
      where_did_you_hear_about_us: obj.where_did_you_hear_about_us || "-",
      city: obj.city || "-",
      validation_status: obj.validation_status || "-",
      validation_status_id: obj.validation_status_id || "",
      answer_type: obj.answer_type || "-",
      state: obj.state || "-",
      lang: obj.lang || "-",
      age_group: obj.age_group || "-",
      occupation: obj.occupation || "-",
      remarks: obj.remarks || "",
      isEditEnabled: obj.isEditEnabled
    };
  }
  updateObjects(arr:any) {
    return arr.map((obj:any) => ({
      id: obj.id || "-",
      reg_id: obj.reg_id || "-",
      user_id: obj.user_id || "-",
      status: obj.status || "-",
      contact_number: obj.contact_number || "-",
      name: obj.name || "-",
      source: obj.source || "-",
      validation_status: obj.validation_status || "-",
      language: obj.language || "-",
      answer_type: obj.answer_type || "-",
      create_dt: obj.create_dt || "-",
      submitted_dt: obj.submitted_dt || "-",
      user_cat: obj.user_cat || "-",
      isEditEnabled: obj.isEditEnabled
    }));
  }

  convertDate(date:any) {
    if(date == "-") {
      return "-";
    }

    return moment(date).format('DD-MM-YYYY');
  }

  maskPhoneNumber(phoneNumber:any) {
    if (typeof phoneNumber !== 'string') {
      phoneNumber = phoneNumber.toString(); // Ensure phoneNumber is a string
    }

    // Mask the phone number
    return phoneNumber.substring(0, 3) + 'xxxx' + phoneNumber.substring(7);
  }

  isNotEditable() {
    const modalRef = this.modalService.open(AlertModalComponent, this.modalOption);
      modalRef.componentInstance.message = "Permission denied";
      modalRef.componentInstance.ConfirmbtnLabel = "Redirect to Dashboard";

      modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {

        console.log(receivedEntry.data, "receivedEntry.data")

        modalRef.close();
        this.router.navigateByUrl(`/validate-dash`);

      })
      modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
        modalRef.close();
    })
  }


  onSubmitConfirmation() {
    const modalRef = this.modalService.open(AlertModalComponent, this.modalOption);
      modalRef.componentInstance.message = "Are you want to submit?";
      modalRef.componentInstance.ConfirmbtnLabel = "Yes";
      modalRef.componentInstance.ClosebtnLabel = "No";

      modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {

        console.log(receivedEntry.data, "receivedEntry.data")

        if(receivedEntry.data == "confirm-submit") {
          this.onSubmit();
        }

        modalRef.close();

      })
      modalRef.componentInstance.close.subscribe((receivedEntry: any) => {
        modalRef.close();
    })
  }

  containsAllowedExtension(url:any) {
    const lowerUrl = url.toLowerCase();
    for (let i = 0; i < this.allowedExtensions.length; i++) {
        const extension = this.allowedExtensions[i];

        if (lowerUrl.includes(`.${extension}`)) {
            return true;
        }
    }
    return false;
  }
  containsAllowedExtensionFiles(url:any) {
    const lowerUrl = url.toLowerCase();
    for (let i = 0; i < this.allowedExtensionFiles.length; i++) {
        const extension = this.allowedExtensionFiles[i];

        if (lowerUrl.includes(`.${extension}`)) {
            return true;
        }
    }
    return false;
  }
  containsAllowedExtensionSrcUrls(url:any) {
    const lowerUrl = url.toLowerCase();
    for (let i = 0; i < this.allowedExtensionSrcUrls.length; i++) {
        const extension = this.allowedExtensionSrcUrls[i];

        if (lowerUrl.includes(`.${extension}`)) {
            return true;
        }
    }
    return false;
  }

  downloadDoc(urlLink:any) {

    this.downloadLoader = true;

    this.validationService.downloadData(urlLink).subscribe({
      next: async (res: Blob) => {
        const url = window.URL.createObjectURL(res);
        const a = document.createElement('a');
        a.href = url;
        console.log(this.getFileNameFromUrl(urlLink), urlLink, "this.getFileNameFromUrl(url)")
        a.download = this.getFileNameFromUrl(urlLink);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.downloadLoader = false;
      },
      error: async (error: any) => {
        this.downloadLoader = false;
      },
    });
  }

  getFileNameFromUrl(url: any) {
    return url.substring(url.lastIndexOf('/') + 1);
  }



  filterUrlsByExtensions(urls:any) {
    // Filter URLs that end with any of the allowed extensions
    return urls.filter((url:any) => {
        const lowerUrl = url.toLowerCase();
        return this.allowedExtensions.some((extension:any) => lowerUrl.includes(`.${extension}`));
    });
  }

}
